/* eslint-disable eqeqeq */
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { SwPush } from '@angular/service-worker';

import { AlertController, LoadingController, PopoverController, ToastController, MenuController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AgentesService } from 'src/app/services/agentes.service';
import { AuthService } from 'src/app/services/auth.service';

import { ChatService } from 'src/app/services/chat.service';
import { ConexionService } from 'src/app/services/conexion.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-perfil-popover',
  templateUrl: './perfil-popover.component.html',
  styleUrls: ['./perfil-popover.component.scss'],
})
export class PerfilPopoverComponent implements OnInit {

  loading: HTMLIonLoadingElement;
  imagenSeleccionada = 'assets/perfilDefault.png';
  tokenNotPush: any;

  idAdmin: any;
  idAdminCanal: any;
  idAgente: any;
  classUser: any;
  nombre: string;
  apellido: string;
  correo: string;
  nombreSucursal: string;
  rol = '';

  formEstados: any;
  estadosAgente: any;
  estadoAgente: string;
  agenteAsignadoGlobal: any;
  enChats: any;

  mensaje = '';
  estadoConexion = 'online';
  colorConexion = true;

  canal: any;
  canales: any;
  selectCanal: any;
  canalInicial: any;

  calificacion: any;
  calificacionColor: any;
  url: any;

  readonly VAPID_PUBLIC_KEY = 'BPMND1TCD6u2cO1sjGh8hgxqdmnNcVi4EmsbFGsQ9L70KTnY5-En56XOQbuDh66PxL11AgzKTgnwcpF4CnbLbMg';

  constructor(
    public alertController: AlertController,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public chat: ChatService,
    private swPush: SwPush,
    private popoverController: PopoverController,
    private conexion: ConexionService,
    private storage: Storage,
    private router: Router,
    private agenteServ: AgentesService,
    private authService: AuthService,
    private whatServ: WhatsappService,
    private notificacion: NotificacionesService,
    private navCtrl: NavController,
    private menu: MenuController,
  ) {
    this.canales = [];
    this.estadosAgente = [];
    this.canalInicial = {};
    this.calificacion = null;
  }

  ngOnInit() {
    this.getCanal();

    this.conexion.estadoConexion$.subscribe(async (estaConectado) => {
      this.estadoConexion = estaConectado ? 'online' : 'offline';
      this.colorConexion = estaConectado ? true : false;

      if (estaConectado) {
        this.mensaje = 'Funcionando';
      } else {
        this.mensaje = 'Sin Red';
      }
    });

    this.classUser = new ValidarToken(this.storage);

    this.storage.get('usuario').then((usuario) => {
      console.log(usuario, 'este es el usuario');

      this.idAdmin = usuario.idAdmin;
      this.idAgente = usuario.idAgente;
      this.agenteAsignadoGlobal = this.idAgente;
      this.rol = this.classUser.rol;
      this.idAdminCanal = usuario.idAdminCanal;
      this.nombre = usuario.nombre;
      this.apellido = usuario.apellido;
      this.correo = usuario.correo;
      this.nombreSucursal = usuario.nombreSucursal;
      // this.formEstados = new FormControl(usuario.estado);
      // this.estadoAgente = usuario.estado;
    }).then(() => {
      this.mostrarImagen();
      this.getCanales();
    });

    this.enChats = this.router.url.includes('/chats');
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    // console.log(this.canal, 'canllllllll header')
    this.selectCanal = new FormControl(this.canal.id);
    // console.log('Entra estados de agente', this.canal.canale.idAdmin_sec, this.canal.id,
    //  this.canal.rol, this.canal.token, this.canal.canale.url_back)
    setTimeout(() => {
      // this.getEstadosAgente();
      this.obtenerCalif();
    }, 500);
  }

  async getCanales() {
    this.canales = await this.storage.get('canales').then();
    console.log(this.canales, 'canales ');
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec === this.idAdmin);
    // console.log(this.canalInicial, 'canal inicallll headerrr')
    this.getEstadosAgente();
    this.getInfoAgente();
    // this.whatsapp.getCanales(this.idAdminCanal, this.classUser.id, this.classUser.rol, this.classUser.token).subscribe(
    //   (data: any) => {  // Usa `any` o define un tipo explícito
    //     // console.log(data, 'Data canales');
    //     const { status } = data;
    //     if (status == 'success') {
    //       this.canales = data.canales;
    //       // console.log(this.storage, 'Storage');
    //     }

    //   },
    //   error => {
    //     console.error(error);
    //   }
    // );
  }

  cambioCanal(ev) {
    const canalNuevo = this.canales.find((canal) => canal.canale.id == ev.detail.value);
    if (canalNuevo) {
      this.storage.remove('canal');
      this.storage.set('canal', canalNuevo.canale);
      this.canal = canalNuevo.canale;
      window.location.reload();
      // console.log(canalNuevo, 'canalNuevo')
    }
  }

  triggerFileInput() {
    const fileInput = document.getElementById('btn-logo-an') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
      // console.log('mostrarImagen', this.idAdmin, this.idAgente, this.classUser);// Dispara el clic del input
    }
  }

  cambiarImagenPerfil(event: any) {
    const archivo = event.target.files[0];
    this.uploadFileMeta(archivo);
  }

  uploadFileMeta(archivo) {
    this.presentLoading('Cargando multimedia');
    const formFile = new FormData();
    formFile.append('file0', archivo);
    formFile.append('file', archivo);

    this.chat.uploadArchivo(formFile, this.classUser.id).subscribe((res: any) => {
      // console.log('uploadArchivo', res);

      if (res.status === 'success') {
        this.loadingController.dismiss();
        this.imagenSeleccionada = res.result.Location;
        this.cambiarFotoPerfil();
      } else {
        this.loadingController.dismiss();
        this.popoverController.dismiss();
        this.presentAlert('Hubo un error', 'no se pudo cargar archivo', 'por favor intenta de nuevo');
      }
    });
  }

  cambiarFotoPerfil() {
    const dataFoto = { foto: this.imagenSeleccionada };

    this.chat.actualizarFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token, dataFoto)
      .subscribe((res: any) => {
        // console.log('actualizarFotoPerfil', res);

        if (res.status === 'success') {
          this.loadingController.dismiss();
          this.popoverController.dismiss(this.imagenSeleccionada);
        } else {
          this.loadingController.dismiss();
          this.popoverController.dismiss();
          this.presentAlert('Hubo un error', 'no se pudo cargar archivo', 'por favor intenta de nuevo');
        }
      });
  }

  mostrarImagen() {
    this.chat.getFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token)
      .subscribe((res: any) => {
        // console.log('mostrarImagen', res);

        if (res.status === 'succeess') {
          this.imagenSeleccionada = res.foto;
        } else {
          this.imagenSeleccionada = 'assets/perfilDefault.png';
        }
      });
  }

  getInfoAgente() {
    this.agenteServ.getAgente(this.canalInicial.canale.idAdmin_sec, this.agenteAsignadoGlobal,
      this.canalInicial.id, this.canalInicial.rol, this.canalInicial.token, this.canalInicial.canale.url_back)
      .subscribe((res: any) => {
        const { status, message, agentes } = res;

        if (status === 'success') {
          this.estadoAgente = agentes.estado;
          this.formEstados = new FormControl(this.estadoAgente);
        }
      });
  }

  getEstadosAgente() {
    // console.log('Entra estados de agente')
    this.chat.getEstadosAgente(this.canalInicial.canale.idAdmin_sec, this.canalInicial.id, this.canalInicial.rol,
      this.canalInicial.token, this.canalInicial.canale.url_back).subscribe((res: any) => {
        const { status } = res;
        console.log(res, 'estqados agente');
        if (status == 'success') {
          const { estados } = res;
          this.estadosAgente = estados;
          // console.log(this.historialTipifiaciones,' array historial')
        }

      });
  }

  cambioEstado(ev) {
    const data = {
      estado: ev.detail.value
    };

    this.canales.forEach(canal => {
      this.servUdateEstado(canal.canale.idAdmin_sec, canal.id, data, canal.rol, canal.token, canal.canale.url_back);
    });
  }

  servUdateEstado(admin, agente, data, rol, token, urlBack) {
    this.agenteServ.actualizarAgente(admin, agente, data, agente, rol, token, urlBack)
      .subscribe((res: any) => {
        console.log(res, 'actualizar');
        const { status } = res;

        if (status == 'success') {
          this.formEstados = new FormControl(data.estado);
          this.estadoAgente = data.estado;

          this.popoverController.dismiss();
          this.alertToast('Exito', 'Se cambio el estado correctamente', 'success');
          // console.log(this.historialTipifiaciones,' array historial')
        }

      });
  }

  obtenerCalif() {
    this.authService.getInfoUser(this.classUser.idAdmin).subscribe((res: any) => {
      this.url = res.url;

      const urlDate = {
        url: this.url
      };

      this.whatServ.consultarCalifiacion(this.canal.idAdmin_sec, this.classUser.id, this.classUser.rol, this.classUser.token, urlDate,
        this.canal.url_back).subscribe((response: any) => {
          console.log('obtenerCalif', response);

          const { status, data } = response;

          if (status == 'success') {
            if (data[0].quality_rating === 'GREEN') {
              this.calificacion = 'Alta';
              this.calificacionColor = 'senalSuccess';
            } else if (data[0].quality_rating === 'YELLOW') {
              this.calificacion = 'Media';
              this.calificacionColor = 'senalWarning';
              this.createNotify(`La calificación de su linea ha pasado de "Alta" a "${this.calificacion}"`);
            } else if (data[0].quality_rating === 'RED') {
              this.calificacion = 'Baja';
              this.calificacionColor = 'senalDanger';
              this.createNotify(`La calificación de su linea ha pasado de "Alta" a "${this.calificacion}"`);
            }
          }
        });
    });
  }

  createNotify(texto: string) {
    const body = { texto, tipo: 'whatsapp' };

    this.notificacion.createNotify(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token,
      this.classUser.canale.url_back, body).subscribe((res: any) => {
        console.log('createNotify', res);
      });
  }

  onFinishSession(idAdmin: number, idUser: number) {
    console.log('onFinishSession', idAdmin, idUser);
    const idUsuario = localStorage.getItem(`sessionId${idUser}`);
    if (!idUsuario) {
      console.error('No se encontró el ID en el localStorage');
      return;
    }

    this.whatServ.finishSession(idAdmin, idUsuario).subscribe(
      (response: { status: string; message: string }) => {
        if (response.status === 'Success') {
          localStorage.removeItem(`sessionId${idUser}`);
        }
      },
      error => {
        console.error('Error al finalizar la sesión:', error);
      }
    );
  }

  notification() {
    this.solicitudNot();
  }

  solicitudNot() {
    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    })
      .then(tokenNotPush => {
        this.tokenNotPush = JSON.parse(JSON.stringify(tokenNotPush));
        this.eliminarKeyNot();
        console.log('entra');
      })
      .catch(err => {
        this.tokenNotPush = err;
        console.log(err);
      });
  }

  eliminarKeyNot() {
    this.storage.get('usuario').then((usuario) => {
      this.whatServ.deletKeyNotPush(this.tokenNotPush, usuario.correo).subscribe(
        (res: any) => {
          console.log('entra');
          if (res.status === 'success') {
            this.storage.remove('idAdmin');
          } else {
            this.presentAlert('Error!', '', 'No se elimino el token');
          }
        },
        error => { console.log(error); }
      );
    });
  }

  cambioPendiente() {
    console.log('cambio pendiente');
    this.storage.get('usuario').then((usuario) => {
      this.classUser = new ValidarToken(this.storage);
      this.storage.get('canales').then((canales) => {
        if (usuario.rol == 'agente' && Array.isArray(canales)) {
          canales.forEach((canal) => {
            this.chat.asignacionPendienteCierreSesion(canal.canale.idAdmin_sec, canal.id, canal.id, canal.rol, canal.token,
              canal.canale.url_back).subscribe((res: any) => {
                console.log('asignacion pendiente', res);
              });
          });
        }
      });
    });
  }

  cerrarSesion() {
    this.canales.forEach(canal => {
      this.onFinishSession(canal.canale.idAdmin_sec, canal.id);
    });
    this.notification();
    this.cambioPendiente();
    setTimeout(() => {
      this.storage.remove('token');
      this.storage.remove('usuario');
      this.storage.remove('canal');
      this.storage.remove('canales');
      this.storage.remove('sesionAgente')
        .then(() => {
          this.menu.close();
          this.navCtrl.navigateForward('/login');
        })
        .then(() => {
          window.location.reload();
        });
    }, 500);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>'
    });
    await this.loading.present();
  }

  async presentAlert(header, subheader, mensaje) {
    const alert = await this.alertController.create({
      cssClass: 'animate__animated animate__fadeIn',
      header,
      subHeader: subheader,
      message: mensaje,
      buttons: ['OK'],
    });

    await alert.present();
  }

  async alertToast(header, mensaje, color) {
    const toast = await this.toastController.create({
      header,
      message: mensaje,
      position: 'bottom',
      cssClass: '',
      color,
      duration: 5000,
    });

    toast.removeAttribute('tabindex');
    await toast.present();

    const { role } = await toast.onDidDismiss();
  }

}
